import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Edit from '@mui/icons-material/Edit';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { editAgent } from 'src/store/actions/agentActions';
import useStyles from '../../styles';
import GeneralAgentInfo from './GeneralInvestorInfo';
import GeneralDetailDialog from './GeneralDetailDialog';

const GeneralAgent = ({ agent }) => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t } = useTranslation();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleSubmit = useCallback(
    values => {
      dispatch(editAgent(id, values, () => handleCloseDialog));
    },
    [agent, id]
  );

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('INVESTORS_VIEW.INVESTOR_DETAIL.GENERAL_DATA')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <GeneralAgentInfo agent={agent} />
          </TableBody>
        </Table>

        <Grid container direction="column" alignItems="stretch">
          <Grid item className={classes.buttons}>
            <Button
              onClick={handleOpenDialog}
              variant="contained"
              color="primary"
              className={clsx(classes.label, classes.buttons)}
              startIcon={<Edit />}
            >
              {t('COMMON.EDIT')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>

      <GeneralDetailDialog
        open={open}
        agent={agent}
        handleClose={handleCloseDialog}
        submit={handleSubmit}
      />
    </Card>
  );
};

GeneralAgent.propTypes = {
  agent: PropTypes.object.isRequired
};

export default GeneralAgent;
